import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import formatMessage from '../format-message';
import generate from 'format-message-generate-id';
var generateId = generate.underscored_crc32;
export function setupFormatMessage(locale) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    translations = _ref.translations,
    logMissingTranslations = _ref.logMissingTranslations;
  formatMessage.setup({
    generateId: generateId,
    locale: locale,
    translations: translations ? _defineProperty({}, locale, translations) : null,
    missingTranslation: logMissingTranslations ? null : 'ignore'
  });
}
export default setupFormatMessage;